import { Card, Col, Row, Statistic, Spin } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { CardRenewalStatistics } from '@mygate/common';

interface CardRenewalStatsProps {
  stats: CardRenewalStatistics | null;
  loading: boolean;
}

export function CardRenewalStats({ stats, loading }: CardRenewalStatsProps) {
  if (loading) {
    return (
      <Card>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <Row className="operational-stats" gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#fff7e6' }}>
          <Statistic
            title="Pending Review"
            value={stats.draft}
            prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#e6f7ff' }}>
          <Statistic
            title="In Progress"
            value={stats.approved + stats.processing}
            prefix={<SyncOutlined style={{ color: '#1890ff' }} />}
            suffix={
              <span style={{ fontSize: 12, color: '#8c8c8c' }}>
                ({stats.approved} approved, {stats.processing} processing)
              </span>
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#f6ffed' }}>
          <Statistic
            title="Completed"
            value={stats.completed}
            prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false}>
          <Row>
            <Col span={12}>
              <Statistic
                title="Rejected"
                value={stats.rejected}
                prefix={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                valueStyle={{ fontSize: 20, color: '#ff4d4f' }}
              />
            </Col>
            <Col span={12}>
              <Statistic title="Cancelled" value={stats.cancelled} valueStyle={{ fontSize: 20, color: '#8c8c8c' }} />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
